module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/thumbs-up-245393c4c007f92ac9ae0f2edae4aa35.svg";